// @ts-expect-error not typed
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
// @ts-expect-error not typed
import { getAsyncComponents } from 'ContentEditorUI/components/AsyncComponents';
// @ts-expect-error not typed
import universalAppReadyMiddleware from 'ContentEditorUI/redux/middleware/universalAppReadyMiddleware';
// @ts-expect-error not typed
import structuredContentModuleRefreshMiddleware from 'ContentEditorUI/redux/middleware/structuredContentModuleRefreshMiddleware';
import lang from 'i2l?query=sporks!case-study-editor-ui/lang/en.lyaml';
// @ts-expect-error not typed
import { getStandardFetchCssRequestOptions } from 'ContentEditorUI/lib/scalableEditor/commonFeatureConfigs';
// @ts-expect-error not typed
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { GET_CONTENT_ASSISTANT_SETTINGS, FETCH_PORTAL_INFO_SUCCESS, FETCH_PORTAL_SCOPES_SUCCESS, FETCH_CONTENT_SCHEMA_SUCCEEDED, I18N_READY } from 'ContentEditorUI/redux/actions/actionTypes';
import { getContentAssistantSettings } from 'ContentEditorUI/redux/actions/contentAssistantActions';
import { buildInitialInstanceEditingState } from 'structured-content-lib/redux/reducers/undoableInstanceEditingReducer';
import { SET_CONTENT_TYPE_SCHEMA_SUCCEEDED, SET_INSTANCE_DATA_SUCCEEDED, SET_TABLE_AS_MODULE_SCHEMA_SUCCEEDED } from 'structured-content-lib/redux/actions/ActionTypes';
import rhumbConfig from '../../../rhumb-config.yaml';
import { rootReducer } from '../../utils/rootReducer';
import Routes from '../../components/Routes';
import { initialRequestActions } from '../initialRequests';
import RootTreeWrapper from '../components/RootTreeWrapper';
import ExtraApplicationContainerComponents from '../components/ExtraApplicationContainerComponents';
import Placeholder from '../components/Placeholder';
import Header from '../components/Header';
import scpPropertyLabelAndDescriptionMiddleware from '../../middleware/scpPropertyLabelAndDescriptionMiddleware';
import { selectCanSave, selectSaveData, save, autoSave, autoSaveDebounced } from '../../data/editor/save';
import { BASE_API_URL } from '../../constants';
import SidebarContainer from '../containers/SidebarContainer';
import { hasViewerPermission, isUngatedForCaseStudies } from 'case-study-lib/utils/auth';
import { selectInstanceName } from '../../data/editor/instance';
import { ContentEditorCopilotCollaborationContextProvider } from 'ContentEditorUI/copilot/ContentEditorCopilotCollaborationContextProvider';
import { CommentObjectType, SUPPORTED_HUBS } from 'collaboration-sidebar';
import { FEATURES } from 'collaboration-sidebar';
import { gate } from 'hub-http/gates';
const AsyncCampaignFieldContainer = makeAsyncComponent(() => import(
// @ts-expect-error not typed
/* webpackChunkName: 'CampaignFieldContainer' */
'ContentEditorUI/containers/settings/CampaignFieldContainer'));
const AsyncPreviewModal = makeAsyncComponent(() => import( /* webpackChunkName: 'PreviewModal' */'case-study-editor-ui/editor/components/PreviewModal'));
const AsyncCollaborationSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'collaboration-sidebar-container' */'ContentEditorUI/containers/CollaborationSidebarContainer'));
const makeInitialState = () => {
  // @ts-expect-error global
  const {
    instanceId
  } = window.parseEditorUrl();
  const currentHubDbRowId = parseInt(instanceId, 10);
  return {
    structuredContent: {
      instanceEditing: buildInitialInstanceEditingState({
        dataAuthoringModeActive: true,
        instanceEditingModeActive: true,
        currentHubDbRowId // TODO update this to be currentInstanceID. Will require changes in CEUI.
      })
    }
  };
};
export const editorConfig = {
  appKey: 'case-study-editor',
  appName: 'case-study-editor-ui',
  features: {
    cssAssets: {
      getFetchCssRequestOptions: getStandardFetchCssRequestOptions
    },
    templateTypes: true,
    shouldUseNopeZonesForAllModules: false,
    shouldFocusSingleStaticModule: false,
    hideLockedEditFormFields: true,
    breakpoints: true,
    undoRedo: true,
    sections: true,
    collaborationSidebar: {
      appName: 'case-study-editor-ui',
      enabledFeatures: [FEATURES.COPILOT],
      objectType: CommentObjectType.UNKNOWN,
      appHub: [SUPPORTED_HUBS.CMS_HUB]
    },
    inlineStyles: true,
    smartContent: true,
    aiGeneratedContent: true,
    quickSpot: false,
    focusMode: false,
    copilotCollaboration: true,
    moduleInsertion: true
  },
  gatedFeatures: {
    copilotCollaboration: ['Chatspot:Widget:Beta', 'Copilot:Collaborate', gate('LFC:CaseStudyEditorCopilot')],
    collaborationSidebar: gate('LFC:CaseStudyEditorCopilot'),
    moduleInsertion: 'StructuredContent:InlineModuleInsertion'
  },
  routes: Routes,
  // Selectors required for the core app to work
  redux: {
    reducers: {
      rootReducer
    },
    selectors: {
      getSaveData: selectSaveData,
      getCanSave: selectCanSave,
      getHasPermissionsToLoadEditor: () => isUngatedForCaseStudies() && hasViewerPermission(),
      getContentName: selectInstanceName
    },
    actions: {
      save,
      autoSave,
      autoSaveDebounced
    },
    checkAppReadyMiddleware: universalAppReadyMiddleware([FETCH_PORTAL_INFO_SUCCESS, FETCH_PORTAL_SCOPES_SUCCESS, SET_CONTENT_TYPE_SCHEMA_SUCCEEDED, SET_INSTANCE_DATA_SUCCEEDED, SET_TABLE_AS_MODULE_SCHEMA_SUCCEEDED, FETCH_CONTENT_SCHEMA_SUCCEEDED, I18N_READY, GET_CONTENT_ASSISTANT_SETTINGS]),
    customMiddlewares: [scpPropertyLabelAndDescriptionMiddleware(), NotificationMiddleware, structuredContentModuleRefreshMiddleware()],
    makeInitialState
  },
  components: {
    asyncComponents: getAsyncComponents({
      extraComponents: {
        CampaignFieldContainer: AsyncCampaignFieldContainer,
        CollaborationSidebarContainer: AsyncCollaborationSidebarContainer,
        PreviewModal: AsyncPreviewModal
      }
    }),
    HeaderExtension: Header,
    TabBarExtension: Placeholder,
    SidebarExtension: SidebarContainer,
    RootTreeWrapper,
    ExtraApplicationContainerComponents,
    CopilotCollaborationContextProvider: ContentEditorCopilotCollaborationContextProvider
  },
  infra: {
    rootUrl: '/case-study/{portalId}/editor',
    rhumbConfig,
    lang
  },
  api: {
    API_BASE_URL: BASE_API_URL,
    initialRequests: [initialRequestActions, getContentAssistantSettings]
  },
  // Uses Redux's mapStateToProps pattern to get the TinyMCE config for the app
  // Must either be an object or a function that takes in the redux state and returns an object
  mapStateToTinyMCEConfig: () => {
    return {
      useEmbed: true,
      usePersonalization: true,
      useSourceCode: true,
      usePersonalizationAsUpgradePoint: false
    };
  }
};